import { Link } from "react-router-dom";

/**
 * Brand logo lockup. Uses the official transparent-background logo asset.
 * variant: "full"  -> complete stacked lockup (footer / standalone)
 *          "nav"   -> shield mark + horizontal wordmark (navigation)
 */
export const Logo = ({ variant = "nav", className = "", to = "/" }) => {
  if (variant === "full") {
    return (
      <Link
        to={to}
        data-testid="brand-logo"
        aria-label="AI First Sports — Home"
        className={`inline-flex items-center transition-opacity duration-300 hover:opacity-90 ${className}`}
      >
        <img
          src="/logo-full.png"
          alt="AI First Sports"
          className="h-16 w-auto object-contain"
          draggable="false"
        />
      </Link>
    );
  }

  return (
    <Link
      to={to}
      data-testid="brand-logo"
      aria-label="AI First Sports — Home"
      className={`group inline-flex items-center gap-2.5 transition-opacity duration-300 hover:opacity-90 ${className}`}
    >
      <img
        src="/logo-mark.png"
        alt="AI First Sports"
        className="h-9 w-auto object-contain sm:h-10"
        draggable="false"
      />
      <span className="flex flex-col leading-none">
        <span className="font-display text-base font-extrabold tracking-tight text-white sm:text-lg">
          AI First
        </span>
        <span className="font-mono-data text-[9px] font-semibold tracking-[0.38em] text-brand-cyan">
          SPORTS
        </span>
      </span>
    </Link>
  );
};

export default Logo;
